"use client";

import { useEffect } from "react";
import * as Swetrix from "swetrix";
import posthog from "posthog-js";

if (typeof window !== "undefined") {
  posthog.init("phc_EH0PW5iaVIPP8ARULJ1rq7fJwtcEIRUle796Q6Ai48D", {
    api_host: "https://us.i.posthog.com",
  });
}

export function AnalyticsScript() {
  useEffect(() => {
    console.log("init");
    Swetrix.init("kF2Qb0DcGFp7");
    void Swetrix.trackViews();
    posthog.capture("page_view");
  }, []);

  return null;
}
